/**
 * Links from the gym-admin app back into the member app.
 *
 * The two are one bundle served on several hosts (`gym.<domain>`,
 * `admin.<domain>` and `app.<domain>`, see `main.tsx`), so a relative path
 * would keep the reader on the admin host and land on the wrong app. Swapping
 * the first label mirrors how `getApiBaseUrl` resolves `api.<domain>`, and it
 * keeps LAN hosts (`gym.192.168.1.93.sslip.io`) working with no config.
 */
export function getMemberAppBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    const labels = hostname.split('.');
    if (labels.length > 1 && ['gym', 'admin', 'app'].includes(labels[0])) {
      labels[0] = 'app';
      return `${protocol}//${labels.join('.')}${port ? `:${port}` : ''}`;
    }
  }

  return 'https://app.divepeaks.local';
}

/** A climb's public page, as an absolute URL fit for `target="_blank"`. */
export function memberAppClimbUrl(gymSlug: string, climbSlug: string): string {
  return `${getMemberAppBaseUrl()}/gyms/${encodeURIComponent(gymSlug)}/climbs/${encodeURIComponent(climbSlug)}`;
}

/**
 * Somebody's public profile, as an absolute URL fit for `target="_blank"`.
 *
 * Addressed by slug, which is what the member app's route takes. Callers have to
 * check there is one: an account nobody has claimed yet has no public profile.
 */
export function memberAppUserUrl(userSlug: string): string {
  return `${getMemberAppBaseUrl()}/users/${encodeURIComponent(userSlug)}`;
}
